export interface MitekMessagesModel {
  [key: string]: { firstMessage: string; fourCornerMessage: string };
}
